import { Container, Grid, Link } from "@mui/material";
import React, {useState , useEffect } from "react";
import DashBoardFooter from "../../../Components/DashboardFooter";
import Loader from "../../../Components/ErroBook/loader";
import ErrorBook from "../../../Components/ErroBook/ntErro"

import logo from "../../../images/logo.png"
import playtable_half from "../../../images/playtable_half.png"

const UpdateScreen = () => {
    const [usePassword, setPassword] = useState('');  
    const [useCPassword, setCPassword] = useState('');  
    
    const [useLoader, setLoader] = useState(false);
    const [useError, setError] = useState(false);
    const [useErrorType, setErrorType] = useState('a');

    useEffect(()=> {
        setTimeout(() => {
            setError(false)
        }, 5000)
    },[]);

    const handleInput = ( e, type) => {
        if (type == 'password'){
            let value = e.target.value;
            setPassword( value )
        } else if (type == 'c-password') {
            let value = e.target.value;
            setCPassword( value )
        }
    }

    const handlReset = () => {
        if (usePassword == "") {
            setErrorType("empty-password")
            setError(true)
            return;
        }else if ( usePassword.length < 6) {
            setErrorType("too-short-password")
            setError(true)
            return;
        }
        setError(false)

        if (useCPassword == "") {
            setErrorType("empty-c-password")
            setError(true)
            return;
        }else if ( useCPassword != usePassword) {
            setErrorType("missmatch-password")
            setError(true)
            return;
        }
        setError(false)

        setLoader(true)
        var tokenValue = window.location.search.split('token=')[1]
        fetch('https://metasnooker.herokuapp.com/api/auth/reset/' + tokenValue,{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                password: usePassword,
                confirmPassword: useCPassword,
            })
        })
        .then(response => response.json())
        .then( jsonData => {
            setLoader(false)
            console.log('Response Data: ', jsonData)
            setErrorType(jsonData.message)
            setError(true)
            localStorage.clear();
            setTimeout(() => {
                window.location.replace("/login");
            }, 5000)
            // if (jsonData.msg == 'duplicate' + useEmail) {
            //     setErrorType("invalid-user")
            //     setError(true)
            // } else {
            //     setErrorType(jsonData.message)
            //     setError(true)  
            //     if (jsonData.token != "" ) {
            //         setErrorType("login-success")
            //         setError(true)  
            //         // Set Item
            //         localStorage.setItem("token", jsonData.user.email);
            //         console.log('User has been logd: ', localStorage.getItem("token") )
            //         window.location.replace("/dashboard");
            //     } 
            // }
        })
    }

    return(
        <div className="AppDapp position-relative">
            { useLoader ? 
                <Loader />
                :
                <span />
            }
            <Container>
                <Grid
                    container
                    justifyContent='center'
                    alignContent="space-between"
                    className="div"
                >
                    <Grid
                        xs={12}
                        sm={8}
                        md={5}
                        lg={7}
                    ></Grid>
                    <Grid
                        xs={11}
                        sm={8}
                        md={7}
                        lg={5}
                        className="text-center mt-sm-5 pt-5"
                    >
                        <Link href="/" className="MS---dashboard--heading d-inline-block position-relative mb-5">
                            Update Password
                        </Link>
                        {useError ?
                            <ErrorBook 
                                errorType = {useErrorType}
                            />
                        :
                            <span />
                        }
                        <div className="MS---dapp_form px-3 py-5 p-sm-5">
                            <form>
                                <label className="mb-2">Enter New Password</label>
                                <input
                                    type='password' 
                                    placeholder="********"
                                    className="mb-3"
                                    value={usePassword}
                                    onChange={(event,type) =>handleInput(event,'password')}
                                />
                                <label className="mb-2">Confirm New Password</label>
                                <input
                                    type='password' 
                                    placeholder="********"
                                    className="mb-3"
                                    value={useCPassword}
                                    onChange={(event,type) =>handleInput(event,'c-password')}
                                />
                                <div className="text-right">
                                    <Link href="/register" className="MS---blue-link">
                                        Register Account
                                    </Link>
                                </div>
                                <button
                                    type="button"
                                    className="MS---Neon--Button btn d-inline-block mt-4 mb-5"
                                    onClick={handlReset}
                                >
                                    Reset Password
                                </button>
                                <p className="mb-0">
                                    <Link href="/login" className="MS---pink-link">Back to Login</Link>
                                </p>
                            </form>
                            </div>
                    </Grid>
                    <Grid
                        container
                        xs={12}
                        className="mt-sm-5 py-5 px-sm-5"
                    >
                        <Grid
                            xs={12}
                            sm={8}
                            className="text-center text-sm-left"
                        >
                            <p className="mb-0">Metasnooker © 2022. All Rights Reserved.</p>
                        </Grid>
                        <Grid
                            xs={12}
                            sm={4}
                            className="text-center text-sm-right mt-4 mt-sm-0"
                        >
                            <Link href="/terms" className="MS---blue-link" target="_blank">
                                Terms & Conditions
                            </Link>
                            &nbsp;&nbsp;&nbsp;
                            <Link href="/privacy-policy" className="MS---blue-link" target="_blank">
                                Privacy Policy
                            </Link>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}

export default UpdateScreen;